import { useEffect } from "react";
import api from "@/lib/api";

const BEAT_MS = 60000;
const IDLE_MS = 5 * 60000;
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel"];

// Tells the server whether this tab is in use ("active"), open but idle, or hidden.
export function usePresence(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    let lastInput = Date.now();
    let lastSent = null;
    let sentAt = 0;

    const state = () => {
      if (document.visibilityState === "hidden") return "hidden";
      return Date.now() - lastInput < IDLE_MS ? "active" : "idle";
    };
    const send = (s = state()) => {
      // Hidden tabs keep checking in as idle so they show Away, not offline.
      const body = s === "hidden" && lastSent === "hidden" ? "idle" : s;
      lastSent = s;
      sentAt = Date.now();
      api.post("/presence", { state: body }).catch(() => {});
    };
    const onInput = () => {
      lastInput = Date.now();
      // Coming back from idle should turn the dot green straight away.
      if (lastSent !== "active" || Date.now() - sentAt > BEAT_MS) send("active");
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") lastInput = Date.now();
      send();
    };

    send("active");
    const timer = setInterval(() => send(), BEAT_MS);
    EVENTS.forEach((e) => window.addEventListener(e, onInput, { passive: true }));
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      clearInterval(timer);
      EVENTS.forEach((e) => window.removeEventListener(e, onInput));
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [enabled]);
}
